// removed by extract-text-webpack-plugin
module.exports = {"CalendarInfo":"CalendarInfo__CalendarInfo__11Rir"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Schedule/UI/CalendarInfo/CalendarInfo.css
// module id = 611
// module chunks = 0